import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { setSearchField, requestUsers } from "../actions/userAction";
import Badge from "react-bootstrap/Badge";
import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";
import UserStats from "../components/UserStats";
import SearchBox from "../components/SearchBox";

const mapStateToProps = (state) => {
  return {
    searchField: state.searchUsers.searchField,
    users: state.requestUsers.users,
    isPending: state.requestUsers.isPending,
    merchantStats: state.merchantStats,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSearchChange: (event) => dispatch(setSearchField(event.target.value)),
    onRequestUsers: () => dispatch(requestUsers()),
  };
};

class UsersContainer extends Component {
  componentDidMount() {
    this.props.onRequestUsers();
    this.props.merchantStats;
  }

  render() {
    const { users, searchField, onSearchChange, merchantStats, isPending } =
      this.props;
    const filteredUsers = users.filter((user) => {
      return (
        user.first_name.toLowerCase().includes(searchField.toLowerCase()) ||
        user.email.toLowerCase().includes(searchField.toLowerCase())
      );
    });
    return (
      <div className="container-fluid">
        <Navbar className="bg-primary justify-content-between">
          <Navbar.Brand>
            Users <Badge variant="light">{users.length}</Badge>
          </Navbar.Brand>
          <SearchBox searchChange={onSearchChange} />
          <Navbar.Text>Cannot Find User?</Navbar.Text>
          <Link to="/create-user">
            <Button variant="primary">Create a New One</Button>
          </Link>
        </Navbar>

        {isPending ? (
          <h1>Loading</h1>
        ) : (
          <UserStats users={filteredUsers} merchants={merchantStats} />
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UsersContainer);
